import { useForm } from "react-hook-form";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import update from "../../../api/auth/storePages/update";
import useStorePageStore from "../../../stores/useStorePageStore";
import { Button, Grid, MenuItem, Stack, Switch, Typography } from "@mui/material";
import WushTextField from "../WushTextField";
import WushCard from "../../layout/WushCard";
import ColorPicker from "../ColorPicker";
import { useEffect, useState } from "react";
import useItemStore from "../../../stores/useItemStore";
import getItemCategories from "../../../api/auth/itemCategories/getItemCategories";
import ItemCategoryName from "../../text/ItemCategoryName";
import WushFileUploader from "../WushFileUploader";
import uploadFile from "../../../api/auth/storePages/uploadFile";
import useAlertStore from "../../../stores/useAlertStore";

export default function StorePageForm({ storePage }) {
  const [ published, setPublished ] = useState(storePage.published);

  const { register, handleSubmit, setValue, reset, formState: { isDirty } } = useForm();

  const { updateStorePage } = useStorePageStore();
  const { itemCategories, setItemCategories } = useItemStore();
  const { setAlertMessage, setAlertType } = useAlertStore();

  const onSubmit = (data) => {
    update(storePage.id, {published, ...data}, (response) => {
      updateStorePage(response);
      reset(response);
    });
  };

  const uploadStoreImage = (file) => {
    uploadFile(storePage.id, file, (response) => {
      setAlertMessage('File uploaded successfully.', 'success');
      updateStorePage(response);
    }, () => {
      setAlertType('error');
      setAlertMessage('Error uploading files. Please try again.');
    });
  };

  useEffect(() => {
    if(itemCategories.length === 0 ) {
      getItemCategories((response) => {
        setItemCategories(response);
      });
    }
  }, []);

  if(!storePage) return (<div>Loading...</div>);

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack direction="row" mb={2}>
          <Switch
            checked={published}
            onChange={(event) => setPublished(event.target.checked)}
            inputProps={{ 'aria-label': 'controlled' }}
          />
          <Typography sx={{ my: "auto" }} variant="body1" fontWeight="700">
            Published
          </Typography>
        </Stack>
        <Grid container spacing={2}>
          <Grid item sm={8}>
            <Stack mb={2}>
              <WushTextField label="Name" formRegistration={register("name")} defaultValue={storePage.name} />
            </Stack>
            <Stack mb={2}>
              <WushTextField label="Description" formRegistration={register("description")} defaultValue={storePage.description} />
            </Stack>
            <Stack mb={2}>
              <ReactQuill
                theme="snow"
                value={storePage.content}
                onChange={(value) => setValue("content", value, { shouldDirty: true})}
              />
            </Stack>
            <Stack direction="row" mb={2} gap={2}>
              <Button disabled={!isDirty && published === storePage.published} type="submit" variant="contained" color="primary">
                Save
              </Button>
              <Button onClick={() =>  window.open(`/store_pages/${storePage.id}/preview`, '_blank') } variant="outlined" color="primary">
                Preview
              </Button>
            </Stack>
          </Grid>
          <Grid item sm={4}>
            <WushCard>
              <Stack p={2} spacing={2}>
                <Stack>
                  <Typography variant="h5">
                    Configuration
                  </Typography>
                </Stack>
                {storePage.image_url && <Stack>
                  <img
                    style={{
                      borderRadius: "5px",
                      marginLeft: "auto",
                      marginRight: "auto"
                    }}
                    width="150px"
                    src={storePage.image_url}
                    alt="Store Image"
                  />
                </Stack>}
                <Stack>
                  <WushFileUploader handleFileUpload={uploadStoreImage} />
                </Stack>
                <Stack direction="row" spacing={2}>
                  <ColorPicker
                    initialValue={storePage.primary_color}
                    onChangeComplete={(color) => setValue("primary_color", color, { shouldDirty: true})}
                  />
                  <Typography sx={{ my: "auto" }} variant="body1" fontWeight="700">
                    Primary Color
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={2}>
                  <ColorPicker
                    initialValue={storePage.secondary_color}
                    onChangeComplete={(color) => setValue("secondary_color", color, { shouldDirty: true})}
                  />
                  <Typography sx={{ my: "auto" }} variant="body1" fontWeight="700">
                    Secondary Color
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={2}>
                  <ColorPicker
                    initialValue={storePage.background_color}
                    onChangeComplete={(color) => setValue("background_color", color, { shouldDirty: true})}
                  />
                  <Typography sx={{ my: "auto" }} variant="body1" fontWeight="700">
                    Background Color
                  </Typography>
                </Stack>
                <Stack>
                  <WushTextField formRegistration={register("item_category_id")} label="Item Category" select defaultValue={storePage?.item_category_id}>
                    {itemCategories.map((itemCategory) => (
                      <MenuItem key={itemCategory.id} value={itemCategory.id}>
                        <ItemCategoryName  itemCategory={itemCategory} />
                      </MenuItem>
                    ))}
                  </WushTextField>
                </Stack>
              </Stack>
            </WushCard>
          </Grid>
        </Grid>

      </form>
    </Stack>
  );
}